import React from "react";

const base =
  "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[12px] leading-5 font-semibold border";

/**
 * StatusPill Component
 * @param {string} status - 'scheduled' | 'live' | 'finished' | 'postponed'
 * @param {string|Date} matchDate - ISO date string or Date object
 */
export default function StatusPill({ status, matchDate, live, postponed, className = "" }) {
  const now = new Date();
  const date = new Date(matchDate);
  const isValidDate = !Number.isNaN(date.getTime());
  const diffHours = isValidDate ? (date - now) / (1000 * 60 * 60) : Infinity;

  if (status === "postponed" || postponed) {
    return <span className={`${base} bg-gray-100 text-gray-700 border-gray-200 ${className}`}>Postponed</span>;
  }

  if (status === "finished") {
    return <span className={`${base} bg-gray-100 text-gray-700 border-gray-200 ${className}`}>FT</span>;
  }

  if (live || status === "live" || (isValidDate && now >= date && diffHours > -2.5)) {
    return (
      <span className={`${base} bg-amber-50 text-amber-900 border-amber-300 ${className}`}>
        <span aria-hidden className="w-1.5 h-1.5 rounded-full bg-amber-500" />
        Live
      </span>
    );
  }

  if (isValidDate && diffHours > 0 && diffHours < 1) {
    return <span className={`${base} bg-amber-50 text-amber-900 border-amber-200 ${className}`}>Starts soon</span>;
  }

  return (
    <span className={`${base} bg-white text-gray-600 border-line tabular-nums ${className}`}>
      {isValidDate
        ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        : "TBD"}
    </span>
  );
}
